import {Component} from 'san';

import styles from './style/index.module.less';

export default class Img extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles
        };
    }
    static computed = {
        src() {
            const type = this.data.get('data.type');
            if (type === 'img') {
                return this.data.get('data.gifsrc') || this.data.get('data.link');
            }
            if (type === 'ARInvoke') {
                return this.data.get('data.data.img');
            }
        },
        width() {
            const type = this.data.get('data.type');
            if (type === 'img') {
                return this.data.get('data.imgWidth');
            }
            if (type === 'ARInvoke') {
                return this.data.get('data.data.width');
            }
        }
    }
};
